import React from 'react'

import Checkbox from 'srcReact/components/common2/Checkbox'

import styles from './styles.module.scss'

const InvitationItem = ({ color, name, letters, checked, organizationPicture, handleClick }) => (
  <div className={styles.containerItem}>
    <div className={styles.containerItem1}>
      <div className={styles.imgContainer}>
        <img src={organizationPicture} alt={name} className={styles.imgLogo} />
        <div className={styles.stroke} />
      </div>
      <div className={`${styles.logoColor} ${styles[color]}`}>{letters}</div>
      <div className={styles.name}>{name}</div>
    </div>
    <div>
      <Checkbox checked={checked} onChange={handleClick} />
    </div>
  </div>
)

export default InvitationItem
